import React from 'react';
import { Check, Crown } from 'lucide-react';
export function Upsell() {
  const categories = [{
    title: '💄 Belleza',
    desc: '5 proveedores mayoristas verificados con precios de lista y contacto directo por WhatsApp'
  }, {
    title: '💪 Fitness',
    desc: '5 proveedores de equipamiento y accesorios deportivos listos para trabajar con revendedores'
  }, {
    title: '📱 Tecnología',
    desc: '5 distribuidores de accesorios tecnológicos con stock consistente y entrega rápida'
  }, {
    title: '🏠 Hogar y Decoración',
    desc: '5 mayoristas de productos de organización y decoración del hogar para el mercado argentino'
  }, {
    title: '🌿 Salud y Bienestar',
    desc: '5 proveedores de productos de salud y bienestar con precios mayoristas para revendedores'
  }];
  return <section className="py-16 md:py-24 px-4 bg-surface/40 border-y border-zinc-800/60" data-id="element-482">
      <div className="max-w-5xl mx-auto" data-id="element-483">
        <div className="text-center mb-10 md:mb-14" data-id="element-484">
          <p className="text-primary font-bold uppercase tracking-widest text-[11px] md:text-sm mb-3 flex items-center justify-center gap-2" data-id="element-485">
            <Crown className="w-4 h-4" data-id="element-486" /> Upgrade premium
          </p>
          <h2 className="text-2xl md:text-4xl font-extrabold mb-6 leading-tight max-w-3xl mx-auto" data-id="element-487">
            🔥 ¿Qué agrega el{' '}
            <span className="text-primary" data-id="element-488">Directorio Exclusivo?</span>
          </h2>
          <p className="text-base md:text-lg text-zinc-300 leading-relaxed max-w-3xl mx-auto" data-id="element-489">
            <span className="text-white font-bold" data-id="element-490">
              25 PROVEEDORES MAYORISTAS VERIFICADOS EN ARGENTINA
            </span>
          </p>
        </div>

        <div className="bg-surface border border-primary/30 rounded-3xl p-6 md:p-10 shadow-[0_0_40px_rgba(245,197,24,0.08)] mb-8" data-id="element-491">
          <div className="grid md:grid-cols-2 gap-4 md:gap-5" data-id="element-492">
            {categories.map((c, i) => <div key={i} className="flex items-start gap-3 bg-black/30 border border-zinc-800/60 rounded-xl p-4 md:p-5" data-id="element-493">
                <div className="bg-primary/20 p-1.5 rounded-full shrink-0 mt-0.5" data-id="element-494">
                  <Check className="w-4 h-4 text-primary" data-id="element-495" />
                </div>
                <div data-id="element-496">
                  <h4 className="text-white font-bold text-base md:text-lg mb-1" data-id="element-497">
                    {c.title}
                  </h4>
                  <p className="text-zinc-300 text-sm md:text-base leading-snug" data-id="element-498">
                    {c.desc}
                  </p>
                </div>
              </div>)}
          </div>
        </div>

        <p className="text-center text-base md:text-xl text-zinc-200 leading-relaxed max-w-2xl mx-auto" data-id="element-499">
          Ideal para empezar a vender en menos de 48hs con{' '}
          <span className="text-primary font-bold" data-id="element-500">
            contactos reales ya verificados.
          </span>
        </p>
      </div>
    </section>;
}